/**
 * Eén plek voor het praten met de server.
 *
 * De drie schermen hadden elk een eigen authFetch, en het leerlingscherm
 * bouwde zijn aanroepen nog met de hand. Nu staat het adres van de server, de
 * Authorization-header en wat er bij een verlopen token moet gebeuren op één
 * plek. Een scherm maakt één keer `const { verzoek } = maakApi({...})` en
 * roept daarna `verzoek('/admin/classes')` -- zonder apiUrl, zonder header.
 *
 * `verzoek` geeft de gewone Response terug; het scherm leest zelf de JSON.
 * Dat is bewust: zo blijft elke bestaande aanroep werken zoals hij werkte,
 * en kan de foutafhandeling per scherm later in één beweging worden
 * rechtgetrokken.
 */
export function maakApi({ apiUrl, token, bijVerlopenToken }) {
  async function verzoek(pad, opties = {}) {
    const headers = { ...(opties.headers || {}) };
    if (token) headers.Authorization = 'Bearer ' + token;
    const response = await fetch(apiUrl + pad, { ...opties, headers });
    // Een 401 na het inloggen betekent: het token is verlopen (na 24 uur) of
    // ongeldig. Dan is niets op het scherm meer te vertrouwen; terug naar
    // het inlogscherm is eerlijker dan een lege lijst.
    if (response.status === 401 && bijVerlopenToken) bijVerlopenToken();
    return response;
  }

  return {
    verzoek,
    /** Het volledige adres van een pad, voor <img src> en dergelijke. */
    url: (pad) => apiUrl + pad,
  };
}
